import { Card, CardBody, CardHeader } from "../card/card.jsx";
import { Spinner } from "react-bootstrap";
function SpinnerSectionContent() {
  return (
    <>
      <div className="d-flex justify-content-center align-items-center">
        <Spinner animation="border" variant="primary" />
      </div>
    </>
  );
}

export default SpinnerSectionContent;
